import React, { useEffect } from 'react';
import SelectField from './form-controls/SelectField';
import FieldHandler from '../../models/interfaces/FieldHandler';
import { Platform } from '../../models/enums/Subscription/Platform';

interface PlatformInputProps extends FieldHandler<number> {
	platformOptions: string[];
 }

const PlatformInput = (props: PlatformInputProps) => {

	const [options, setOptions] = React.useState<Platform[]>([]);

	useEffect(() => {
		const opts = props.platformOptions.map((platform: string) => {
			const platformEnum = new Platform().fromName(platform);
			return platformEnum;
		});

		setOptions(opts);
	},[])

	return (
		<SelectField
			label="Platform"
			className="full-width"
			options={options}
			disabled
			{...props}
		/>
	);
}

export { PlatformInput };